import React, { Component } from 'react'

export default class contentView extends Component {
  
  render() {
    const { title, smallT, content } = this.props;
    return (
      <div className="Product--item__text">
        <p className="content-item-title">{title}</p>
        <p className="content-item-subtitle">{smallT}</p>
        <p className="content-item-desc">{content}</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/contentView.js